/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import { buildNode as buildLiteralNode, toElasticsearchQuery as literalToElasticsearchQuery, toKqlExpression as literalToKqlExpression } from '../node_types/literal';
export const KQL_FUNCTION_EXISTS = 'exists';
export function isNode(node) {
  return node.function === KQL_FUNCTION_EXISTS;
}
export function buildNodeParams(fieldName) {
  return {
    arguments: [buildLiteralNode(fieldName)]
  };
}
export function toElasticsearchQuery(node, indexPattern, config = {}, context = {}) {
  var _indexPattern$fields;
  const {
    arguments: [fieldNameArg]
  } = node;
  const fullFieldNameArg = {
    ...fieldNameArg,
    value: context !== null && context !== void 0 && context.nested ? `${context.nested.path}.${fieldNameArg.value}` : fieldNameArg.value
  };
  const fieldName = literalToElasticsearchQuery(fullFieldNameArg);
  const field = indexPattern === null || indexPattern === void 0 ? void 0 : (_indexPattern$fields = indexPattern.fields) === null || _indexPattern$fields === void 0 ? void 0 : _indexPattern$fields.find(fld => fld.name === fieldName);
  if (field !== null && field !== void 0 && field.scripted) {
    throw new Error(`Exists query does not support scripted fields`);
  }
  return {
    exists: {
      field: fieldName
    }
  };
}
export function toKqlExpression(node) {
  const [field] = node.arguments;
  return `${literalToKqlExpression(field)}: *`;
}